/**
 * HITL (Human-in-the-Loop) state store (session only — no persistence).
 * Holds pending agent queries keyed by workItemId.
 *
 * Implements: FR-HITL.2.1, FR-HITL.2.2
 */
import { create } from 'zustand';
import type { AgentQueryEvent } from '../types/socket';

interface HitlState {
  /** Pending agent queries keyed by workItemId. */
  pendingQueries: Record<string, AgentQueryEvent>;
  setPendingQuery: (workItemId: string, event: AgentQueryEvent) => void;
  clearPendingQuery: (workItemId: string) => void;
}

export const useHitlStore = create<HitlState>((set) => ({
  pendingQueries: {},

  setPendingQuery: (workItemId, event) =>
    set((state) => ({
      pendingQueries: { ...state.pendingQueries, [workItemId]: event },
    })),

  clearPendingQuery: (workItemId) =>
    set((state) => {
      const next = { ...state.pendingQueries };
      delete next[workItemId];
      return { pendingQueries: next };
    }),
}));
